import React from "react";
import { withTranslation } from "react-i18next";
import PropTypes from "prop-types";
import { DivBackgroundOpacity } from "@utils/extra-style";

const SiteInfo = (props) => {
  const { t, data, isActive } = props;

  return (
    <>
      <DivBackgroundOpacity opacity={isActive ? 1 : "0.2"}>
        {data}
      </DivBackgroundOpacity>
    </>
  );
};

SiteInfo.propTypes = {
  t: PropTypes.func.isRequired,
};

export default withTranslation()(SiteInfo);
